<template>
  <div class="menu__dish-card mb-2" @click="$emit('click')">
    <div class="k-menu__dish">
      <div class="k-menu__dish-photo col-sm-3 col-lg-4 p-0 d-flex align-items-center mr-2">
        <img v-if="cover_url" class="k-menu__dish-img" :src="cover_url"/>
      </div>
      <div class="k-menu__dish-body">
        <div class="k-menu__dish-description">
              <span class="d-flex flex-column">
                {{ title }}
              </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DishCard",
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    cover_url: {
      type: String,
      required: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.menu__dish-card {
  user-select: none;

  -ms-flex-preferred-size: 400px;
  flex-basis: 400px;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  margin-right: 10px;
  margin-left: 10px;
}
</style>
